import styles from './Modal.module.scss';
import { useModalContext } from './ModalContext';
import clsx from 'clsx';
import React, { useEffect } from 'react';

const ModalHeader = ({
  illustration,
  suppressed,
  children,
  description,
  title,
}) => {
  const { setHasModalTitle, isMobileFullPage } = useModalContext();

  const classes = clsx(styles.modalSection, styles[suppressed], {
    [` ${styles.mobile}`]: isMobileFullPage,
  });

  useEffect(() => {
    if (title) setHasModalTitle && setHasModalTitle(true);
    return () => {
      setHasModalTitle && setHasModalTitle(false);
    };
  }, [title, setHasModalTitle]);

  const hasHeader = title || description;

  // Update title div for a title component
  // Update span text to a text component
  return (
    <div className={classes}>
      {hasHeader && (
        <div className={styles.modalTitle}>
          {title && <div>{title}</div>}
          {description && (
            <div className={styles.modalDescription}>
              <span size="large" as="div">
                {description}
              </span>
            </div>
          )}
        </div>
      )}
      {children && <div description={!!description}>{children}</div>}
      {title && <div isMobileFullPage={isMobileFullPage}>{title}</div>}
    </div>
  );
};

export default ModalHeader;
